<script lang="ts">

    import Router from 'svelte-spa-router';
    import { wrap } from 'svelte-spa-router/wrap';

    // svelte-spa-router's `wrap` types don't fully line up with Svelte 4
    // component types, so the async loader is typed loosely here.
    const lazy = (loader: () => Promise<unknown>) =>
        wrap({ asyncComponent: loader as never });

    // Lazy-loaded routes: each component is bundled into its own chunk and
    // only fetched over the network when its route is first visited.
    const routes = {
        // Using named parameters, with last being optional
        '/c1/:message': lazy(() => import('./C1.svelte')),
        '/c2/:message': lazy(() => import('./C2.svelte')),
        '/C3/:message': lazy(() => import('./C3.svelte')),
        '/Test': lazy(() => import('./Test.svelte')),
        '*': lazy(() => import('./Home.svelte')),
    };

</script>
<div style="display:flex;flex-direction: column;">

    <div style="display:flex; flex-direction: row;">
        <a href="#/home">home</a>
        <a href="#/C1/welcome%20to%20component1">C1</a>
        <a href="#/C2/here%20is%20component2">C2</a>
        <a href="#/C3/component3%20is%20in%20the%20place">C3</a>
        <a href="#/test">TEST</a>
    </div>
    <hr>
 <Router {routes}/> 
</div>